module.exports = __webpack_public_path__ + "img/fill.f57fa9c7.svg";